import { NavLink } from 'react-router';
import React, { useState } from 'react';
import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import { authConfig } from '../../_Auth/AuthSettings';

function SignupDevNav() {
	const [tokenShow, setTokenShow] = useState<boolean>(false);

	return (
		<>
			<div className='btn-group text-center'>
				<NavLink to='/' className='btn secondary'>
					Old Signup
				</NavLink>
				<NavLink to='/signup-3' className='btn secondary'>
					New Signup
				</NavLink>
				<Button
					title='Show Token'
					onClick={() => setTokenShow(!tokenShow)}
					colour={tokenShow ? ColourStateSolid.Success : ColourStateSolid.Secondary}
				/>
			</div>

			{tokenShow && <div style={{ whiteSpace: 'pre' }}>{JSON.stringify(authConfig, null, 4)}</div>}
		</>
	);
}

export default SignupDevNav;
